import { render, staticRenderFns } from "./LKRoadmapsFeedFilterExpertStatus.vue?vue&type=template&id=3445e8ae&"
import script from "./LKRoadmapsFeedFilterExpertStatus.vue?vue&type=script&lang=js&"
export * from "./LKRoadmapsFeedFilterExpertStatus.vue?vue&type=script&lang=js&"
import style0 from "./LKRoadmapsFeedFilterExpertStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
